import { render, staticRenderFns } from "./RegistrosMva.vue?vue&type=template&id=fa2e0f44&scoped=true&"
import script from "./RegistrosMva.vue?vue&type=script&lang=js&"
export * from "./RegistrosMva.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosMva.vue?vue&type=style&index=0&id=fa2e0f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2e0f44",
  null
  
)

export default component.exports